import { BOARD, GO_SALARY, GROUP_INFO } from "@grundbesitz/shared";
import type { PublicGameState } from "@grundbesitz/shared";
import { formatMoney } from "../../lib/format";

/** "3 Häuser", "Hotel", "1 Haus" ... for a building count (5 = hotel). */
export function buildingsText(buildings: number): string | null {
  if (buildings <= 0) return null;
  if (buildings >= 5) return "Hotel";
  return buildings === 1 ? "1 Haus" : `${buildings} Häuser`;
}

/** Screen reader label of a board field: "Opernplatz, Gruppe Rot, Preis M 240, Besitzer Anna, 2 Häuser, belastet". */
export function describeField(index: number, game: PublicGameState): string {
  const field = BOARD[index];
  if (!field) return `Feld ${index}`;
  const nameOf = (id: string) => game.players.find((p) => p.id === id)?.name ?? "Unbekannt";
  const parts: string[] = [field.name];

  switch (field.kind) {
    case "STREET":
      parts.push(`Gruppe ${GROUP_INFO[field.group].name}`, `Preis ${formatMoney(field.price)}`);
      break;
    case "RAILROAD":
      parts.push("Bahnhof", `Preis ${formatMoney(field.price)}`);
      break;
    case "UTILITY":
      parts.push("Werk", `Preis ${formatMoney(field.price)}`);
      break;
    case "TAX":
      parts.push(`Steuer ${formatMoney(field.amount)}`);
      break;
    case "CHANCE":
      parts.push("Ereigniskarte ziehen");
      break;
    case "COMMUNITY":
      parts.push("Gemeinschaftskarte ziehen");
      break;
    case "GO":
      parts.push(`${formatMoney(GO_SALARY)} beim Überqueren`);
      break;
    case "FREE_PARKING":
      if (game.options.houseRules.freeParkingPot) parts.push(`Topf ${formatMoney(game.freeParkingPot)}`);
      break;
    case "JAIL":
    case "GO_TO_JAIL":
      break;
  }

  const prop = game.properties[index];
  if (prop && (field.kind === "STREET" || field.kind === "RAILROAD" || field.kind === "UTILITY")) {
    parts.push(prop.owner ? `Besitzer ${nameOf(prop.owner)}` : "ohne Besitzer");
    const b = buildingsText(prop.buildings);
    if (b) parts.push(b);
    if (prop.mortgaged) parts.push("belastet");
  }

  const here = game.players.filter((p) => !p.eliminated && p.position === index);
  if (index === 10) {
    const inside = here.filter((p) => p.inJail).map((p) => p.name);
    const visiting = here.filter((p) => !p.inJail).map((p) => p.name);
    if (inside.length) parts.push(`im Gefängnis: ${inside.join(", ")}`);
    if (visiting.length) parts.push(`zu Besuch: ${visiting.join(", ")}`);
  } else if (here.length) {
    parts.push(`Figuren: ${here.map((p) => p.name).join(", ")}`);
  }
  return parts.join(", ");
}
